namespace GeniuzPOS.Inventory {
    export interface IcStockApproveReportData extends Serenity.ListRequest {
        Header?: IcStockApproveHdRow;
        Details?: IcStockApproveDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
